import React from 'react';

class Preloader extends React.Component {
    
    render() {
        let tmpurl = "";
        return (
            <div>
                {/* Go to Top Link */}
                <a href={tmpurl} className="back-to-top">
                    <i className="lni-arrow-up"></i>
                </a>

                {/*  Preloader */}
                <div id="preloader">
                    <div className="loader" id="loader-1"></div>
                </div>
            </div>
        )
    }
}

export default Preloader;


// WEBPACK FOOTER //
// ./src/layouts/Preloader.js